export default {
  id: 233,
  title: 'Target #233 - Pendulum',
  url: 'https://cssbattle.dev/play/233',
  colors: ['#F4DA64', '#469DBA'],
  solution:
    '<p a><p b><p c><p d><style>p[b],p[c]{width:100;height:50}p[c],p[d]{background:#469dba}body{background:#f4da64}p{position:fixed;margin:0}p[a]{top:125;left:100;width:150;height:75;border-radius:9in 9in 0 0;border:25px solid #469dba;border-bottom-width:0}p[b]{top:225;left:125;border-radius:0 0 9in 9in;border:25px solid #469dba;border-top-width:0}p[c]{top:175;left:150}p[d]{top:0;left:187;width:26;height:290',
}
